import React from 'react'
import { useSelector } from 'react-redux'

import useConfig from '@/features/configs/useConfig'
import useOfferList from '@/features/offers/hooks/useOfferList'
import { authSelector } from '@/stores/auth/authSlice'
import { Flex } from '@chakra-ui/react'
import BaseOfferTaskWidget from './BaseOfferTaskWidget'
import OfferTaskButton from './OfferTaskButton'
import { GCPRStatus, PRApprovalStatus, ApprovalInvitationStatus } from '@eapproval/offer-shared'

const MyGCPRApprovalWidget = () => {
  const { user } = useSelector(authSelector)

  const { useFetchGCPRApprovals } = useOfferList()
  const { data: GCPRApprovalResponse } = useFetchGCPRApprovals({
    page: 1,
    pageSize: 0,
    filters: {
      actionUser: user?.fullName || '',
    },
  })

  const baseLink = '/offers/gcpr-approvals'
  const actionUserQuery = `actionUser=${encodeURIComponent(user?.fullName || '')}`
  const validSubmissionStatus = [GCPRStatus.APPROVED, GCPRStatus.REJECTED, GCPRStatus.SUBMITTED, GCPRStatus.DRAFT]

  const upcomingCount =
    (Array.isArray(GCPRApprovalResponse?.data?.data)
      ? GCPRApprovalResponse.data.data.filter(
          (item) =>
            item.approvalStatus === PRApprovalStatus.UPCOMING &&
            validSubmissionStatus.includes(item.GCPRSubmissionStatus)
        )
      : []
    ).length || 0

  const actionRequiredStatus = [PRApprovalStatus.REQUIRED, ApprovalInvitationStatus.INVITED]

  const actionRequiredCount =
    (Array.isArray(GCPRApprovalResponse?.data?.data)
      ? GCPRApprovalResponse.data.data.filter(
          (item) =>
            actionRequiredStatus.includes(item.approvalStatus) &&
            validSubmissionStatus.includes(item.GCPRSubmissionStatus)
        )
      : []
    ).length || 0

  const processedStatus = [PRApprovalStatus.APPROVED, PRApprovalStatus.REJECTED, ApprovalInvitationStatus.REPLIED]

  const processedCount =
    (Array.isArray(GCPRApprovalResponse?.data?.data)
      ? GCPRApprovalResponse.data.data.filter(
          (item) =>
            processedStatus.includes(item.approvalStatus) && validSubmissionStatus.includes(item.GCPRSubmissionStatus)
        )
      : []
    ).length || 0

  return (
    <BaseOfferTaskWidget title={'My GCPR Approval'}>
      <Flex gap="5" direction={['column', 'row']} wrap="wrap">
        <OfferTaskButton
          color="teal"
          buttonText={'Upcoming'}
          count={upcomingCount}
          link={
            baseLink +
            `?approvalStatus=${PRApprovalStatus.UPCOMING}&${actionUserQuery}&GCPRSubmissionStatus=${validSubmissionStatus.join('%2C')}`
          }
        />
        <OfferTaskButton
          color="teal"
          buttonText={'Action Required'}
          count={actionRequiredCount}
          link={
            baseLink +
            `?approvalStatus=${actionRequiredStatus.join('%2C')}&${actionUserQuery}&GCPRSubmissionStatus=${validSubmissionStatus.join('%2C')}`
          }
        />
        <OfferTaskButton
          color="teal"
          buttonText={'Processed'}
          count={processedCount}
          link={
            baseLink +
            `?approvalStatus=${processedStatus.join('%2C')}&${actionUserQuery}&GCPRSubmissionStatus=${validSubmissionStatus.join('%2C')}`
          }
        />
      </Flex>
    </BaseOfferTaskWidget>
  )
}

export default MyGCPRApprovalWidget
